import React from 'react';
import { Box, Grid, Typography, Avatar, Card, CardContent } from '@mui/material';
import { styled } from '@mui/material/styles';

// Testimonial data
const testimonials = [
  {
    name: 'Priya Ostwal',
    role: 'Marketing Manager, PhysicsWallah',
    text: 'Vertex Suite team has shown exceptional professionalism, reliability and a true commitment to customer satisfaction.',
    avatarBgColor: '#4CAF50',
  },
  {
    name: 'Akash Jain',
    role: 'Business Executive, COSCO',
    text: "Vertex Suite helped us increase our customer engagement. Our customer engagement increased from 35% to 90% with Vertex's Smart Retargeting feature.",
    avatarBgColor: '#FF9800',
  },
  {
    name: 'Achina Maya',
    role: 'Founder & CEO, AEVYTV',
    text: 'Vertex Suite has been pivotal for us. The personalised interactions and instant responses greatly improved our engagement rates and more importantly our sales!',
    avatarBgColor: '#AB47BC',
  },
];

// Styled components for glassmorphism and animation
const GlassCard = styled(Card)(({ theme }) => ({
    background: 'rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderRadius: '16px',
    boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.4s ease-in-out',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    height: '100%', // Ensures all cards take full height of grid item
    '&:hover': {
        transform: 'scale(1.05) translateY(-10px)',
        boxShadow: '0 12px 40px rgba(0, 0, 0, 0.2)',
        background: 'rgba(255, 255, 255, 0.15)',
        cursor: 'pointer',
    },
    '&:hover .avatar': {
        transform: 'rotate(360deg)',
        boxShadow: '0 0 15px rgba(0, 0, 0, 0.3)',
    },
    '&:hover .content': {
        transform: 'translateY(-5px)',
    },
    [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(1),
    },
}));

const StyledAvatar = styled(Avatar)({
  width: 80,
  height: 80,
  margin: '0 auto',
  transition: 'transform 0.6s ease-in-out',
});

const ContentBox = styled(Box)({
  transition: 'transform 0.4s ease-in-out',
});

const TestimonialsSection = () => {
  return (
    <Box 
    sx={{ 
        py: { xs: 4, md: 8 }, 
        backgroundImage: `url('bg3.svg')`,
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: 'white'
        }}
        >
      <Typography
        variant="h3"
        align="center"
        fontWeight="bold"
        gutterBottom
        sx={{ mb: { xs: 4, md: 6 }, fontSize: { xs: '2rem', md: '3rem' }, px: 2, }}
      >
        Hear it from our Customers!
      </Typography>
      <Box
        sx={{
          px: { xs: 2, sm: 4, md: 8, lg: 12 },
          width: { xs: '100%', sm: '95%', md: '90%', lg: '80%', xl: '74%' },
          mx: 'auto',
        }}
      >
        <Grid container spacing={{ xs: 2, md: 4 }} justifyContent="center">
          {testimonials.map((testimonial, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <GlassCard>
                <CardContent sx={{ p: { xs: 2, md: 4 }, textAlign: 'center' }}>
                  <StyledAvatar
                    className="avatar"
                    sx={{ bgcolor: testimonial.avatarBgColor }}
                  >
                    {testimonial.name[0]}
                  </StyledAvatar>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    color={'#fff'}
                    sx={{ mt: 2, mb: 1, fontSize: { xs: '1.2rem', md: '1.5rem' } }}
                  >
                    {testimonial.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    color={`${testimonial.avatarBgColor}`}
                    sx={{ mb: 2, fontSize: { xs: '0.9rem', md: '1rem' } }}
                  >
                    {testimonial.role}
                  </Typography>
                  <ContentBox className="content">
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { xs: '0.9rem', md: '1rem' },
                        lineHeight: 1.6,
                        color: 'rgba(255, 255, 255, 0.56)'
                      }}
                    >
                      {testimonial.text}
                    </Typography>
                  </ContentBox>
                </CardContent>
              </GlassCard>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default TestimonialsSection;